import { useRef, useContext, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Tab, Popup } from 'semantic-ui-react';
import './styles/DashboardCrecerComponent.js';
import { DashboardCrecerComponent } from './styles/DashboardCrecerComponent.js';
import { GuestDashboardContext } from './guestDashboardContext.js';
import { dayInTZ } from '../../components/helpers/index.js';
import CertificateGenerator from './CertificateGenerator.jsx';
import NotificationModal from '../../components/helpers/NotificationModal.jsx';
import Button from '../../components/common/Button.jsx';
import { handleCrecerCompletion } from 'src/components/helpers/crecer.jsx';
import { formatCompletedAttendance } from 'src/components/eventsLogin/AttendanceModal.jsx';
import { AttendanceLegend } from 'src/containers/crecer/autoAsistencia/styles';

const StickyLegendWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f6fbff;
  margin: 0;
  padding: 8px 18px;
`;

const Crecer = () => {
  const { crecerDates, guest } = useContext(GuestDashboardContext);
  const [notificationHeader, setNotificationHeader] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationOpen, setNotificationOpen] = useState(false);

  const [selectedCourse, setSelectedCourse] = useState(null);
  useEffect(() => {
    if (selectedCourse && pdfRef.current) {
      pdfRef.current.downloadPdf();
      setSelectedCourse(null);
    }
  }, [selectedCourse]);
  const today = new Date();
  const pdfRef = useRef();

  const attendanceStatus = (content, date) => {
    const attended = content?.[date.attendanceCode];
    const attendanceInfo = content?.[date.attendanceCode];
    const isJan2000 = dayInTZ(content?.[date.attendanceCode], 'YYYY-MM-DD') === '2000-01-01';
    const colorClass = !!attended
      ? isJan2000
        ? 'status-date-orange'
        : 'status-date-green'
      : 'status-false';
    return (
      <Popup
        trigger={
          <span
            className={`status-indicator status-indicator--hover ${colorClass}`}
            role="img"
            aria-label={attended ? 'Asistió' : 'No asistió'}
          >
            {!!attended ? '✓' : '✕'}
          </span>
        }
        content={formatCompletedAttendance(attendanceInfo, 'DD [de] MMMM [de] YYYY')}
        position="top center"
        on="hover"
      />
    );
  };

  const CrecerSteps = [
    {
      id: 1,
      name: `Paso 1 - Encuentro`,
      event: 'crecerEncuentro',
      stepsMade: guest.CrecerEncuentroSteps,
    },
    {
      id: 2,
      name: `Paso 2 - Vida`,
      event: 'crecerVida',
      stepsMade: guest.CrecerVidaSteps,
    },
    {
      id: 3,
      name: `Paso 3 - Influencia`,
      event: 'crecerInfluence',
      stepsMade: guest.CrecerInfluenceSteps,
    },
  ];

  const CrecerNextClasses = [
    {
      id: 1,
      name: `Vida`,
      event: 'crecerVida',
    },
    {
      id: 2,
      name: `Influencia`,
      event: 'crecerInfluence',
    },
  ];

  const setNotificationError = (message) => {
    setNotificationHeader('Error al descargar el certificado');
    setNotificationMessage(message);
    setNotificationOpen(true);
  };

  const getSeminaryClasses = (seminary) => {
    return guest.Seminaries?.find((attendance) => attendance.seminary === seminary);
  };

  const Seminarios = [
    {
      id: 1,
      name: `Para Siempre`,
      event: 'ParaSiempre',
      stepsMade: getSeminaryClasses('ParaSiempre'),
    },
    {
      id: 2,
      name: `Proyecto Matrimonio`,
      event: 'ProyectoMatrimonio',
      stepsMade: getSeminaryClasses('ProyectoMatrimonio'),
    },
    {
      id: 3,
      name: `Escuela de héroes`,
      event: 'EscueladeHeroes',
      stepsMade: getSeminaryClasses('EscueladeHeroes'),
    },
    {
      id: 4,
      name: `Relaciones Sanas`,
      event: 'RelacionesSanas',
      stepsMade: getSeminaryClasses('RelacionesSanas'),
    },
    {
      id: 5,
      name: `Transformación Empresarial`,
      event: 'TransformacionEmpresarial',
      stepsMade: getSeminaryClasses('TransformacionEmpresarial'),
    },
    {
      id: 6,
      name: `Ruta 128`,
      event: 'Ruta128',
      stepsMade: getSeminaryClasses('Ruta128'),
    },
  ];

  const panes = [
    {
      menuItem: 'Crecer',
      render: () => (
        <Tab.Pane className="custom-pane" style={{ paddingTop: '0px' }}>
          <StickyLegendWrapper>{attendanceLegend}</StickyLegendWrapper>
          <div className="columns">
            {!!crecerDates.length &&
              [CrecerSteps[0]].map((step) => (
                <div className="column" style={{ textAlign: 'center' }} key={step.event}>
                  <h3
                    style={{ fontWeight: 500, color: '#00c47a', textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: step.name }}
                  />
                  {!!step?.stepsMade?.[0]?.percentage && (
                    <>
                      <li className="step-item title virtual">
                        <span>Virtual</span>
                        <span className="percentage">{step?.stepsMade?.[0]?.percentage || 0}%</span>
                      </li>
                      <li className="step-item title">
                        <span>Presencial</span>
                        <span />
                      </li>
                    </>
                  )}
                  <ul>
                    {crecerDates
                      ?.filter((d) => d.event === step.event)
                      ?.map((date) => (
                        <li key={date.id} className="step-item">
                          <span>{date.attendanceName}</span>
                          {attendanceStatus(step.stepsMade?.[0], date)}
                        </li>
                      ))}
                  </ul>
                </div>
              ))}
            {!!crecerDates.length &&
              [CrecerSteps[1], CrecerSteps[2]].map((step) => (
                <div className="column" style={{ textAlign: 'center' }} key={step.event}>
                  <h3
                    style={{ fontWeight: 500, color: '#00c47a', textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: step.name }}
                  />
                  <ul>
                    {!!step?.stepsMade?.[0]?.percentage && (
                      <>
                        <li className="step-item title virtual">
                          <span>Virtual</span>
                          <span className="percentage">
                            {step?.stepsMade?.[0]?.percentage || 0}%
                          </span>
                        </li>
                        <li className="step-item title">
                          <span>Presencial</span>
                          <span />
                        </li>
                      </>
                    )}
                    {crecerDates
                      ?.filter((d) => d.event === step.event)
                      ?.map((date) => (
                        <li key={date.id} className="step-item">
                          <span>{date.attendanceName}</span>
                          {attendanceStatus(step.stepsMade?.[0], date)}
                        </li>
                      ))}
                  </ul>
                  <Button
                    text={`Descargar Certificado`}
                    disabled={false}
                    onClick={() =>
                      handleCrecerCompletion({
                        courseCode: step.event,
                        guest,
                        setSelectedCourse,
                        setNotificationError,
                      })
                    }
                  />
                </div>
              ))}
            {!!crecerDates.length &&
              CrecerNextClasses?.map((step) => (
                <div className="column next-classes" key={step.name}>
                  <h3 className="sticky-header">
                    <span style={{ color: '#191919' }}>Próximas Clases</span>
                    <span className="sub">{step.name}</span>
                  </h3>
                  <p className="attendance-sign">
                    Puedes asistir a las clases que te hagan falta en estas fechas:
                  </p>
                  <ul>
                    {crecerDates
                      ?.filter((date) => {
                        const attendanceDate = new Date(date.attendanceDate);
                        return attendanceDate >= today && date.event === step?.event;
                      })
                      .map((date) => (
                        <li
                          key={date.id}
                          style={{
                            marginBottom: '15px',
                            background: '#FFF',
                            borderRadius: '8px',
                            padding: '5px',
                            border: '1px solid #191919',
                          }}
                        >
                          <div style={{ fontWeight: '500' }}>{date.attendanceName}</div>
                          <div style={{ fontSize: '14px', color: '#767676' }}>
                            {dayInTZ(date.attendanceDate, 'MMMM DD [de] yyyy')}
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              ))}
          </div>
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Seminarios',
      render: () => (
        <Tab.Pane className="custom-pane" style={{ paddingTop: '0px' }}>
          <StickyLegendWrapper>{attendanceLegend}</StickyLegendWrapper>
          <div className="columns">
            {!!Seminarios.length &&
              Seminarios.map((step) => (
                <div className="column" style={{ textAlign: 'center' }} key={step.event}>
                  <h3
                    style={{ fontWeight: 500, color: '#ff776a', textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: step.name }}
                  />
                  <ul>
                    {crecerDates
                      ?.filter((d) => d.event === step.event)
                      ?.map((date) => (
                        <li key={date.id} className="step-item">
                          <span>{date.attendanceName}</span>
                          {attendanceStatus(step.stepsMade, date)}
                        </li>
                      ))}
                  </ul>
                  <Button
                    text={`Descargar Certificado`}
                    disabled={false}
                    onClick={() =>
                      handleCrecerCompletion({
                        courseCode: step.event,
                        guest,
                        setSelectedCourse,
                        setNotificationError,
                      })
                    }
                  />
                </div>
              ))}
          </div>
        </Tab.Pane>
      ),
    },
  ];

  const attendanceLegend = (
    <AttendanceLegend>
      <span className="legend-item">
        <span className="status-indicator status-date-green">✓</span>
        Completado
      </span>
      <span className="legend-item">
        <span className="status-indicator status-date-orange">✓</span>
        Marcado por el usuario
      </span>
      <span className="legend-item">
        <span className="status-indicator status-false">✕</span>
        Sin completar
      </span>
    </AttendanceLegend>
  );

  return (
    <DashboardCrecerComponent>
      <div style={{ display: 'none' }}>
        {selectedCourse && (
          <CertificateGenerator
            ref={pdfRef}
            studentName={`${guest.name} ${guest.lastName}`}
            course={selectedCourse}
          />
        )}
      </div>
      <h2 style={{ fontSize: '30px', color: '#5f5f5f', fontWeight: 400 }}>Tus pasos en</h2>
      <h2 className="title">Crecer & Seminarios</h2>
      <Tab panes={panes} />
      <NotificationModal
        header={notificationHeader}
        message={notificationMessage}
        open={notificationOpen}
        onClose={() => setNotificationOpen(false)}
      />
    </DashboardCrecerComponent>
  );
};

export default Crecer;
